import { computed, onMounted, onUnmounted, ref } from 'vue';

/** 判定为桌面/键鼠优先环境（非手机触控为主） */
function isDesktopLike(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}

function isLandscapeViewport(): boolean {
  if (typeof window === 'undefined') return false;
  const viewport = window.visualViewport;
  const width = viewport?.width ?? window.innerWidth;
  const height = viewport?.height ?? window.innerHeight;
  return width > height;
}

const desktopLike = ref(isDesktopLike());
const landscape = ref(isLandscapeViewport());
const isPC = computed(() => desktopLike.value && landscape.value);
const isLandscape = computed(() => landscape.value);
const isPortrait = computed(() => !landscape.value);
let consumerCount = 0;
let orientationFrame: number | null = null;
let visualViewport: VisualViewport | null = null;

function refresh() {
  desktopLike.value = isDesktopLike();
  landscape.value = isLandscapeViewport();
}

function handleOrientationChange() {
  refresh();
  if (orientationFrame !== null) window.cancelAnimationFrame(orientationFrame);
  orientationFrame = window.requestAnimationFrame(() => {
    orientationFrame = null;
    refresh();
  });
}

function startListening() {
  consumerCount += 1;
  refresh();
  if (consumerCount > 1) return;

  visualViewport = window.visualViewport;
  window.addEventListener('resize', refresh);
  window.addEventListener('orientationchange', handleOrientationChange);
  visualViewport?.addEventListener('resize', refresh);
}

function stopListening() {
  consumerCount -= 1;
  if (consumerCount > 0) return;
  consumerCount = 0;

  window.removeEventListener('resize', refresh);
  window.removeEventListener('orientationchange', handleOrientationChange);
  visualViewport?.removeEventListener('resize', refresh);
  visualViewport = null;
  if (orientationFrame !== null) {
    window.cancelAnimationFrame(orientationFrame);
    orientationFrame = null;
  }
}

/** 供非 setup 场景复用的 PC 判定（与 hook 内 isPC 同源） */
export function isPCViewport(): boolean {
  return isDesktopLike() && isLandscapeViewport();
}

/**
 * PC 端或横屏视口时拦截主应用，仅展示引导页（手机竖屏）。
 */
export function useViewportAccessGate() {
  refresh();
  onMounted(startListening);
  onUnmounted(stopListening);

  return { isPC, isLandscape, isPortrait };
}
